import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

export function useFetch(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    if (!path) return;
    setLoading(true); setError("");
    try { setData((await api.get(path)).data); } catch (e) { setError(errMsg(e)); } finally { setLoading(false); }
  }, [path]); // api/errMsg are stable module imports — only path should retrigger. eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, [reload]);
  return { data, setData, error, loading, reload };
}
